import React from 'react'
import PropTypes from 'prop-types'
import Active from './components/Active/Active.component'
import Skeleton from 'shared/components/common/Skeleton/Skeleton.component'
import Popover from 'shared/components/common/Popover/Popover.component'
import PopoverSection from 'shared/components/common/Popover/components/Section/Section.component'
import PopoverMenu from 'shared/components/common/Popover/components/Menu/Menu.component'
import PopoverItem from 'shared/components/common/Popover/components/Item/Item.component'
import Scrollable from 'shared/components/common/Scrollable/Scrollable.component'
import { createDivAtom } from 'shared/atoms/factory'

import styles from './Projects.module.scss'

const SkeletonWrapper = createDivAtom()
const sortByName = (a,b) => (a.name.localeCompare(b.name))

const renderAgentItems = (agents, onClick) => agents.map((item, i) => (
  <PopoverItem
    key={i}
    avatar
    title={item.name}
    onClick={onClick(item)}
  />
))

const Projects = ({
  agent,
  agents,
  projects,
  selectAgent,
  fetchProjectInfo
}) => {
  let popover
  const isAgentLoaded = agent?.agentId !== 'default'
  const isAgentsLoaded = Array.isArray(agents)

  const onItemClick = selectedAgentOrProject => () => {
    if(popover) popover.hide()

    if(selectedAgentOrProject.projectId) fetchProjectInfo(selectedAgentOrProject.projectId)
    else selectAgent(selectedAgentOrProject)
  }

  const allProjects = [ ...projects, ...agents ].sort(sortByName)
  if(agent.projectId && Array.isArray(projects)){
    //If agent belong to project change disaplay name, because in projects list we disaply project name not agent name (for versions) 
    const project = projects.find(p => p.projectId === agent.projectId)
    if(project?.name !== '') agent.name = project.name
  }
  return (
    <main>
      {
        isAgentLoaded
          ? (
            <Popover
              ref={ref => popover = ref}
              trigger={<Active agent={agent} />}
              showChevron
            >
              <PopoverMenu>

                <PopoverSection
                  title='Switch project'
                  align='left'
                >
                  <Scrollable
                    className={styles.scrollable}
                  >

                    {
                      isAgentsLoaded
                        ? renderAgentItems(allProjects, onItemClick)
                        : <span className={styles.noContent} >No Projects</span>
                    }

                  </Scrollable>
                </PopoverSection>

              </PopoverMenu>
            </Popover>
          )
          : (
            <SkeletonWrapper
              className={styles.wrapper}
            >
              <Skeleton
                width="22px"
                height="22px"
              />
              <Skeleton
                width="80px"
                height="8px"
                style={{
                  marginLeft: '16px'
                }}
              />
            </SkeletonWrapper>
          )
      }
    </main>
  )
}

Projects.propTypes = {
  agent: PropTypes.object.isRequired,
  agents: PropTypes.any,
  projects: PropTypes.array,
  fetchProjectInfo: PropTypes.func,
  selectAgent: PropTypes.func
}

export default Projects
